import { Injectable } from '@angular/core'
import { AngularFireDatabase } from 'angularfire2/database'
import { Observable } from 'rxjs/Observable'
import * as firebase from 'firebase'
import * as geoFire from 'geofire'

import { UserService } from '../user.service'
import { GeolocationService } from '../../../geolocation/geolocation.service'
import { environment } from '../../../../environments/environment'


@Injectable()
export class UserLocationService {

  private readonly firebaseRef = firebase.database().ref(environment.firebaseRoot)
  private readonly geoFire = new geoFire(this.firebaseRef.child('geofire'))

  constructor(private geolocationService: GeolocationService,
    private db: AngularFireDatabase) { }

  public setLocation(uid: string, lat: number, lng: number): Observable<any> {
    return Observable.forkJoin([
      Observable.fromPromise(this.geoFire.set(uid, [lat, lng])),
      this.setAddressToDatabase(uid, lat, lng)
    ])
  }

  public getLocation(uid: string): Observable<number[]> {
    return Observable.fromPromise(this.geoFire.get(uid))
  }

  public onLocationChange(uid: string, flag = true): Observable<number[]> {
    const locationRef = this.firebaseRef.child(`geofire/${uid}`)
    return this.db.object(locationRef)
      .do(a => console.log(a))
      .filter((item: any) => item.$value)
      .map((item: any) => [item.l[0], item.l[1]])
      .do((latLng: number[]) => {
        this.setAddressToDatabase(uid, latLng[0], latLng[1])
      })
  }

  private setAddressToDatabase(uid: string, lat: number, lng: number): Observable<any> {
    return this.geolocationService.getFormattedAddress(lat, lng)
      .mergeMap((address: string) => {
        const addressParts = address.split(',')

        // Remove state from address
        if (addressParts.length === 3) {
          addressParts.splice(1, 1)
        }

        const [city, country] = addressParts.map(item => item.trim())

        const updates = {}
        updates[`users/${uid}/city`] = city
        updates[`users/${uid}/country`] = country

        return Observable.fromPromise(<Promise<any>>this.firebaseRef.update(updates))
      })
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/users/shared/user-location/user-location.service.ts